import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'displayNewLines'
})
export class DisplayNewLinesPipe implements PipeTransform {

    transform(value: string): string {
        return !value ? '' : value.replace(/\n/g, '<br>');
    } // transform()

} // DisplayNewLinesPipe
